import * as React from 'react';
export const listSvg = React.forwardRef(function listSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.5 1.75C2.5 2.438 1.937 3 1.25 3 .562 3 0 2.45 0 1.75 0 1.062.563.5 1.25.5c.688 0 1.25.563 1.25 1.25Zm1.75-.8a.8.8 0 0 0 0 1.6h6.752a.8.8 0 1 0 0-1.6H4.25Zm-3 6.3c.688 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25C.562 4.75 0 5.313 0 6c0 .7.563 1.25 1.25 1.25Zm3-2.05a.8.8 0 0 0 0 1.6h6.752a.8.8 0 1 0 0-1.6H4.25Zm-3 6.3c.688 0 1.25-.563 1.25-1.25C2.5 9.562 1.937 9 1.25 9 .562 9 0 9.563 0 10.25c0 .7.563 1.25 1.25 1.25Zm3-2.05a.8.8 0 1 0 0 1.6h6.752a.8.8 0 1 0 0-1.6H4.25Z',
    }),
  );
});
listSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var list = {
  category: 'icon',
  colorable: true,
  name: 'list',
  svg: listSvg,
};
